module.exports = __webpack_public_path__ + "img/img13.37cab4e0.png";